<style>
  body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 1rem;
    line-height: 1.6;
    background-color: #f9f9f9;
    color: #333;
  }
  h1, h2, h3 {
    color: #2c3e50;
  }
  .container {
    max-width: 900px;
    margin: auto;
    background: #fff;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  ul {
    margin-left: 1.5rem;
  }
  .contact {
    margin-top: 2rem;
    background: #f2f2f2;
    padding: 1rem;
    border-left: 5px solid #007BFF;
  }
</style>
<div class="container">
  <h1>Privacy Policy</h1>
  <p><strong>Last Updated:</strong> 20th July 2024</p>
  <p>Snithik Technologies Pvt Ltd (“FleetConnect,” “we,” “our,” “us”) values your privacy. This Privacy Policy outlines
    how we collect, use, disclose, and protect your information when you use our website, mobile application, or any
    other platform/tool developed by FleetConnect (collectively referred to as the “Platform”). By accessing or using
    our Platform, you agree to the practices described in this Privacy Policy. Please read it carefully.</p>

  <h2>Introduction</h2>
  <p>This Privacy Policy applies to the use of our website <a href="https://snithik.com/FleetConnect">www.snithik.com/FleetConnect</a>,
    FleetConnect mobile application, and any platform/tool developed by Snithik Technologies Pvt Ltd.</p>

  <h2>Purpose</h2>
  <p>This Privacy Policy aims to help you understand:</p>
  <ul>
    <li>The types of Personal Information (including Sensitive Personal Data or Information) that we collect from you
    </li>
    <li>The reasons for collecting and how we use such Personal Information</li>
    <li>How and with whom we may share this information</li>
    <li>How we protect your Personal Information</li>
    <li>How you can access and update your Personal Information</li>
  </ul>

  <h2>Personal Information / Sensitive Personal Data</h2>
  <p>“Personal Information” refers to any information that identifies you or could be used to identify you.</p>
  <p>“Sensitive Personal Data or Information” includes:</p>
  <ul>
    <li>Passwords</li>
    <li>Financial details (bank account, card details)</li>
    <li>Health conditions</li>
    <li>Sexual orientation</li>
    <li>Medical records/history</li>
    <li>Biometric data</li>
    <li>Other similar data provided to the Company</li>
  </ul>

  <h2>Types of Personal Information We Collect</h2>
  <ul>
    <li>Name</li>
    <li>User ID</li>
    <li>Email address</li>
    <li>Address (including country and ZIP/postal code)</li>
    <li>Phone number</li>
    <li>Password</li>
    <li>Geolocation via IP</li>
    <li>Bank account details, GST, PAN Card, etc.</li>
    <li>Information related to your customers/buyers</li>
    <li>Documents such as Aadhaar, PAN, GST certificate</li>
  </ul>

  <h2>Automatic Data Collection</h2>
  <p>We may collect browsing behavior, IP address, operating system, browser type, ISP, and use cookies for
    administration and research purposes.</p>

  <h2>Use of Collected Information</h2>
  <p>We may use your data to:</p>
  <ul>
    <li>Register and manage your account</li>
    <li>Process orders and services</li>
    <li>Send updates to you/customers</li>
    <li>Complete transactions</li>
    <li>Administer and personalize the Platform</li>
    <li>Display relevant ads</li>
    <li>Conduct research and analysis</li>
    <li>Respond to queries and complaints</li>
    <li>Comply with legal obligations</li>
  </ul>

  <h2>Disclosure and Transfer of Information</h2>
  <p>We may share your information with service providers, government bodies (as required), employees, processors, or
    vendors on a need-to-know basis.</p>

  <h2>Security Practices</h2>
  <p>We implement reasonable measures to protect your information, but cannot guarantee complete security due to
    internet vulnerabilities.</p>

  <h2>User Rights</h2>
  <p>You can access, modify, or delete your Personal Information by contacting us. Withdrawal of consent is not
    retroactive.</p>

  <h2>Retention of Information</h2>
  <p>We retain data as needed for service delivery and legal compliance. Canceled registrations may still be retained
    for required periods.</p>

  <h2>Changes to this Privacy Policy</h2>
  <p>We may update this Policy periodically. Continued use of our Services indicates acceptance of the latest
    version.</p>

  <h2>Contact Us</h2>
  <div class="contact">
    <p><strong>Grievance Officer:</strong>Sandeep Kumar</p>
    <p><strong>Company:</strong> Snithik Technologies Pvt Ltd</p>
    <p><strong>Address:</strong> 3rd Floor, RRR Residency, Brindavan Colony
      Kokapet, Hyderabad, Telangana - 500075, India</p>
    <p><strong>Email:</strong> <a href="mailto:support&#64;snithik.com">support&#64;snithik.com</a></p>
  </div>
</div>

